export default __webpack_public_path__ + "static/media/bio.5bb8ac74.png";